module.exports = __webpack_public_path__ + "staticcomp/img/content_1.6cd4560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/2/content_1.jpg
// module id = X8at
// module chunks = 39